<span style="font-size: medium;" [innerHTML]="value | renderHtml"></span>